import { createApiCall2, MethodType, URI } from "../Api";
import { FullStressTypeInfoData } from "models/stressCheck/fullStressInformation";
import { MiniStressTypeInfoData } from "models/stressCheck/miniStressInformation";
import { SendFullStressNotificationData } from "models/stressCheck/fullStressSendNotification";
import { SendHighStressNotificationData } from "models/stressCheck/sendHighStressNotification";
import { SendMiniStressNotificationData } from "models/stressCheck/miniStressSendNotification";
import { IFullStressTypeDownloadPdfData } from "models/stressCheck/fullStressTypeDownloadPdf";
import { IFullStressTypeDownloadCsvData } from "models/stressCheck/fullStressTypeDownloadCsv";
import { IMiniStressTypeDownloadPdfData } from "models/stressCheck/miniStressTypeDownloadPdf";
import { IMiniStressTypeDownloadCsvData } from "models/stressCheck/miniStressTypeDownloadCsv";
import { IMiniStressScoringPayload } from "models/stressCheck/miniStressScoringInformation";
import { IFullStressScoringPayload } from "models/stressCheck/fullStressScoringInformation";
import { StressCheckListData } from "models/stressCheck/stressCheckList";
import { NewStressCheckData } from "models/stressCheck/newStressCheck";
import { UpdateStressCheckData } from "models/stressCheck/updateStressCheck";
import { DeleteStressCheckData } from "models/stressCheck/deleteStressCheck";
import { StressCheckDetailsData } from "models/stressCheck/stressCheckDetails";
import { IFactorsNEffectsPayload } from "models/stressCheck/factorsNEffects";

export const getFullStressTypeInfoRequests = (
  payload: FullStressTypeInfoData
) => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.FULL_STRESS_TYPE_INFO,
    payload
  );
};

export const getMiniStressTypeInfoRequests = (
  payload: MiniStressTypeInfoData
) => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.MINI_STRESS_TYPE_INFO,
    payload
  );
};

export const sendFullStressNotification = (
  payload: SendFullStressNotificationData
) => {
  return createApiCall2(
    MethodType.POST,
    URI.STRESS_CHECK.FULL_STRESS_NOTIFICATION,
    payload
  );
};

export const sendHighStressNotification = (
  payload: SendHighStressNotificationData
) => {
  return createApiCall2(
    MethodType.POST,
    URI.STRESS_CHECK.HIGH_STRESS_NOTIFICATION,
    payload
  );
};

export const sendMiniStressNotification = (
  payload: SendMiniStressNotificationData
) => {
  return createApiCall2(
    MethodType.POST,
    URI.STRESS_CHECK.MINI_STRESS_NOTIFICATION,
    payload
  );
};

export const downloadFullStressPdfRequest = (
  payload: IFullStressTypeDownloadPdfData
) => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.FULL_STRESS_DOWNLOAD_PDF,
    payload
  );
};

export const downloadFullStressCsvRequest = (
  payload: IFullStressTypeDownloadCsvData
) => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.FULL_STRESS_DOWNLOAD_CSV,
    payload
  );
};

export const downloadMiniStressPdfRequest = (
  payload: IMiniStressTypeDownloadPdfData
) => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.MINI_STRESS_DOWNLOAD_PDF,
    payload
  );
};
export const downloadMiniStressCsvRequest = (
  payload: IMiniStressTypeDownloadCsvData
) => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.MINI_STRESS_DOWNLOAD_CSV,
    payload
  );
};

export const getFullStressScoringInfomation = (
  payload: IFullStressScoringPayload
) => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.FULL_STRESS_SCORING,
    payload
  );
};

export const getMiniStressScoringInfomation = (
  payload: IMiniStressScoringPayload
) => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.MINI_STRESS_SCORING,
    payload
  );
};

export const getStressCheckDetails = (payload: StressCheckDetailsData) => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.STRESS_CHECK_DETAILS,
    payload
  );
};

export const saveNewStressCheck = (payload: NewStressCheckData) => {
  return createApiCall2(
    MethodType.POST,
    URI.STRESS_CHECK.STRESS_CHECK_CREATE,
    payload
  );
};

export const updateStressCheck = (payload: UpdateStressCheckData) => {
  return createApiCall2(
    MethodType.PUT,
    URI.STRESS_CHECK.STRESS_CHECK_UPDATE,
    payload
  );
};

export const deleteStressCheck = (payload: DeleteStressCheckData) => {
  return createApiCall2(
    MethodType.DELETE,
    URI.STRESS_CHECK.STRESS_CHECK_DELETE,
    payload
  );
};

export const getStressCheckList = (payload: StressCheckListData) => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.STRESS_CHECK_LIST,
    payload
  );
};

export const getStressSituation = () => {
  return createApiCall2(MethodType.GET, URI.STRESS_CHECK.GRAPH_1);
};

export const getFactorsnEffects = (payload: IFactorsNEffectsPayload) => {
  return createApiCall2(MethodType.GET, URI.STRESS_CHECK.GRAPH_2, payload);
};

export const getChangeStress = (payload: any) => {
  return createApiCall2(MethodType.GET, URI.STRESS_CHECK.GRAPH_3, payload);
};

export const getDepartmentList = () => {
  return createApiCall2(MethodType.GET, URI.STRESS_CHECK.DEPARTMENT_LIST);
};

export const getFullStressLastNotificationTime = () => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.FULL_STRESS_LAST_NOTIFICATION
  );
};
export const getMiniStressLastNotificationTime = () => {
  return createApiCall2(
    MethodType.GET,
    URI.STRESS_CHECK.MINI_STRESS_LAST_NOTIFICATION
  );
};
